var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMapMarker({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 18L7.4325 11.55C6.68488 10.6673 6.20343 9.59036 6.04422 8.44462C5.885 7.29887 6.05457 6.13147 6.53318 5.07837C7.01179 4.02527 7.77974 3.12981 8.74759 2.49629C9.71545 1.86277 10.8434 1.51726 12 1.5C13.6033 1.51584 15.135 2.16645 16.2596 3.30931C17.3842 4.45218 18.01 5.99415 18 7.5975C18.0006 8.9962 17.5244 10.3533 16.65 11.445L12 18ZM12 3C10.7939 3.01385 9.64257 3.50578 8.79886 4.36778C7.95514 5.22977 7.488 6.39137 7.5 7.5975C7.50502 8.69837 7.90109 9.76163 8.6175 10.5975L12 15.39L15.4725 10.5C16.1326 9.67608 16.4947 8.6532 16.5 7.5975C16.512 6.39137 16.0449 5.22977 15.2011 4.36778C14.3574 3.50578 13.2061 3.01385 12 3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.25C12.8284 8.25 13.5 7.57843 13.5 6.75C13.5 5.92157 12.8284 5.25 12 5.25C11.1716 5.25 10.5 5.92157 10.5 6.75C10.5 7.57843 11.1716 8.25 12 8.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 9H19.5V10.5H21V21H3V10.5H4.5V9H3C2.60218 9 2.22064 9.15804 1.93934 9.43934C1.65804 9.72064 1.5 10.1022 1.5 10.5V21C1.5 21.3978 1.65804 21.7794 1.93934 22.0607C2.22064 22.342 2.60218 22.5 3 22.5H21C21.3978 22.5 21.7794 22.342 22.0607 22.0607C22.342 21.7794 22.5 21.3978 22.5 21V10.5C22.5 10.1022 22.342 9.72064 22.0607 9.43934C21.7794 9.15804 21.3978 9 21 9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMapMarker);
export default __webpack_public_path__ + "static/media/ic-map-marker.cf55a94db3bebbd16d226b38410d6b1f.svg";
export { ForwardRef as ReactComponent };